import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import AddProductForm from '../components/AddProductForm'

const AddProduct = () => {
    return (
        <div>
            <Header />
            <AddProductForm />
            <Footer />
        </div>
    )
}

export default AddProduct
